export function nbspReplace(text: string): string {
    return text.replace(/[ ]/g, '&nbsp;');
}
